import * as strings from '../../assets/strings';
import { CredenciaisService } from './credenciais.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { NotificacaoSistema } from '../models/integra/notificacao-sistema';
import { HttpBaseService } from './http-base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class NotificacaoIntegraSistema {
  public notificacaoSistema : NotificacaoSistema;  

  constructor(private credenciaisService: CredenciaisService,
    private http: HttpBaseService,
    private httpclient: HttpClient,
    private router: Router) { }

    public CadastraNotificacao(pessoaFisicaId:number, setor:string, tipo:string, titulo:string, observacao:string, modulo:string, local:string)
    {
      this.notificacaoSistema = new NotificacaoSistema(0,null,null,null,null,null,null,null,null,null,null,null);
      this.notificacaoSistema.id = 0;
      this.notificacaoSistema.flgVisto = false;
      this.notificacaoSistema.pessoaFisicaId = pessoaFisicaId;
      this.notificacaoSistema.tipo = tipo;//"alert"
      this.notificacaoSistema.titulo = titulo;//"Cadastro de Chamado";
      this.notificacaoSistema.observacao = observacao;//"Chamado de nº " + codChamado + " foi criado.";
      this.notificacaoSistema.modulo = modulo;//"chamadoatividade";
      this.notificacaoSistema.setor = setor;
      this.notificacaoSistema.local = local;
  
      this.http.post(`/NotificacaoSistema/InsereNotificacao`, true, this.notificacaoSistema).subscribe((result) => {
        //console.log("CadastraNotificacao",result)
        return result;
      });
    }

    public NotificaWhatsApp(idChave:number, modulo:string, tipo:string): Observable<any> {
    {
      this.http.get( `/dominio/BuscarInfoMakeWebHook/LinkMakeWebhook/${tipo}`, false).subscribe((info: any) => {
        let urlWebhook = info.detalhamento;
        let urlCompleta = `${urlWebhook}?id=${idChave}&modulo=${modulo}`;
        //console.log("NotificaWhatsappp---url", urlCompleta)
        return this.httpclient.get<any>(urlCompleta).subscribe(r =>{r/*console.log("NotificaWhatsApp",r)*/});
      });   

      return null;  
    }
  }
    
}
